export default __webpack_public_path__ + "static/media/signinsplash.9ea7764a.png";